<template>
  <div>
    <ShareDetailToolbar/>
    <v-tabs :color="ui.bkgdColor" :slider-color="ui.sliderColor" v-model="tab">
      <v-tab href="#tab-1">
        <v-tabs-slider/>
        <div :class="ui.textColorSecondary">
          Info
        </div>
      </v-tab>
      <v-tab href="#tab-2">
        <div :class="ui.textColorSecondary">
          Event
        </div>
      </v-tab>
      <v-tab href="#tab-3">
        <div :class="ui.textColorSecondary">
          Detail
        </div>
      </v-tab>
      <v-tab href="#tab-4">
        <div :class="ui.textColorSecondary">
          Site
        </div>
      </v-tab>
      <v-tab href="#tab-5">
        <div :class="ui.textColorSecondary">
          Scope
        </div>
      </v-tab>
      <v-tab href="#tab-6">
        <div :class="ui.textColorSecondary">
          Hazards
        </div>
      </v-tab>
      <v-tab href="#tab-7">
        <div :class="ui.textColorSecondary">
          Impacts
        </div>
      </v-tab>
      <v-tab href="#tab-8">
        <div :class="ui.textColorSecondary">
          Assess
        </div>
      </v-tab>
      <v-tab href="#tab-9">
        <div class="body wplblue0--text">
          Study
        </div>
      </v-tab>
      <v-tab href="#tab-10">
        <div class="body wplblue0--text">
          Roles
        </div>
      </v-tab>
      <v-tab href="#tab-11">
        <div class="body wplblue0--text">
          Actions
        </div>
      </v-tab>
      <v-tab href="#tab-12">
        <div class="body wplblue0--text">
          Trans
        </div>
      </v-tab>
      <v-tab href="#tab-13">
        <div class="body wplblue0--text">
          Attach
        </div>
      </v-tab>
      <v-tab href="#tab-14">
        <div class="body wplblue0--text">
          Relps.
        </div>
      </v-tab>
      <v-tab href="#tab-15">
        <div class="body wplblue0--text">
          Revs.
        </div>
      </v-tab>
      <!-- Basic / Info -->
      <v-tab-item :key="1" :value="'tab-1'">
        <ShareDetailInfo/>
      </v-tab-item>
      <!-- Risk Context -->
      <v-tab-item :key="2" :value="'tab-2'">
        <IncidentDetailEvent v-if="this.tab === 'tab-2'"/>
      </v-tab-item>
      <!-- Risk Identify -->
      <v-tab-item :key="3" :value="'tab-3'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-3'">
          <IncidentDetailDescribe/>
        </v-container>
      </v-tab-item>
      <!-- Risk Analysis  -->
      <v-tab-item :key="4" :value="'tab-4'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-4'">
          <ShareDetailSite/>
        </v-container>
      </v-tab-item>
      <!-- Site -->
      <v-tab-item :key="5" :value="'tab-5'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-5'">
          <ShareDetailScope/>
        </v-container>
      </v-tab-item>
      <!-- Risk Barriers -->
      <v-tab-item :key="6" :value="'tab-6'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-6'">
          <HazardRegister/>
        </v-container>
      </v-tab-item>
      <!-- Hazards -->
      <v-tab-item :key="7" :value="'tab-7'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-7'">
          <ShareDetailImpact/>
        </v-container>
      </v-tab-item>
      <!-- Risk Ownership -->
      <v-tab-item :key="8" :value="'tab-8'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-8'">
          <RiskAssessment/>
        </v-container>
      </v-tab-item>
      <!-- Risk Register -->
      <v-tab-item :key="9" :value="'tab-9'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-9'">
          <ShareDetailClose/>
        </v-container>
      </v-tab-item>
      <!-- Roles -->
      <v-tab-item :key="10" :value="'tab-10'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-10'">
          <Roles/>
        </v-container>
      </v-tab-item>
      <!-- Relps -->
      <v-tab-item :key="11" :value="'tab-11'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-11'">
          <ActionsRegister/>
        </v-container>
      </v-tab-item>
      <v-tab-item :key="12" :value="'tab-12'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-12'">
          <Transitions/>
        </v-container>
      </v-tab-item>
      <!-- Roles and Resposbilities -->
      <v-tab-item :key="13" :value="'tab-13'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-13'">
          <Attachments/>
        </v-container>
      </v-tab-item>
      <v-tab-item :key="14" :value="'tab-14'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-14'">
          <RelationshipRegister/>
        </v-container>
      </v-tab-item>
      <v-tab-item :key="15" :value="'tab-15'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-15'">
          <RevisionDash/>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <DetailChange/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ShareDetailInfo from "@/support/share/components/ShareDetailInfo";
import IncidentDetailEvent from "@/safety/incident/components/IncidentDetailEvent";
import IncidentDetailDescribe from "@/safety/incident/components/IncidentDetailDescribe";
import ShareDetailSite from "@/support/share/components/ShareDetailSite";
import ShareDetailScope from "@/support/share/components/ShareDetailScope";
import ShareDetailImpact from "@/support/share/components/ShareDetailImpact";
import ShareDetailClose from "@/support/share/components/ShareDetailClose";
import HazardRegister from "@/safety/hazard/components/HazardRegister";
import RiskAssessment from "@/safety/assessment/components/RiskAssessment";
import Transitions from "@/support/transitions/components/Transitions";
import Roles from "@/support/roles/components/Roles";
import RevisionDash from "@/document/revisions/components/RevisionDash";
import DetailChange from "@/support/detail/components/DetailChange";
import Attachments from "@/document/attachments/components/Attachments";
import RelationshipRegister from "@/data/list/components/RelationshipRegister";
import ActionsRegister from "@/business/actions/components/ActionsRegister";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ShareDetailToolbar from "@/support/share/components/ShareDetailToolbar";

export default {
  components: {
    DetailChange,
    ShareDetailInfo,
    IncidentDetailEvent,
    HazardRegister,
    IncidentDetailDescribe,
    ShareDetailScope,
    ShareDetailImpact,
    RiskAssessment,
    ShareDetailClose,
    Attachments,
    ActionsRegister,
    ShareDetailSite,
    RelationshipRegister,
    Roles,
    RevisionDash,
    Transitions,
    ShareDetailToolbar
  },
  // eslint-disable-next-line
  mixins: [apptheme, storeFunctions],
  data() {
    return {
      valid: true,
      value: "",
      tab: ""
    };
  },
  beforeDestroy() {
    this.$store.dispatch("changeDocumentRevMod", null);
    // this.resetStoreDetail();
  },
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDetail", "getAsset", "getDataSavePendingIndication"]),
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    }
  }
};
</script>
